import { Button } from '@huntington/honeycomb';
import { ColorBaseGreenEnergy, ColorBaseWhite } from '@huntington/honeycomb-design';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { Box, Stack, Typography } from '@mui/material';
import {
	SUCCESS_CONTINUE_BUTTON,
	SUCCESS_HEADER,
	SUCCESS_MESSAGE,
} from '../../../constants/messages';
import { ROUTE_LOGIN } from '../../../router/router';
import './DisclosureAcceptanceSuccess.scss';

export default function DisclosureAcceptanceSuccess() {
	return (
		<Box className="content-container">
			<Box className="upper-container">
				<Stack alignItems="center">
					<CheckCircle sx={{ color: ColorBaseGreenEnergy, height: '3rem', width: '3rem' }} />
					<Typography
						component="h1"
						variant="h1"
						sx={{ color: ColorBaseGreenEnergy, font: 'bold 2.25rem "Huntington Serif", serif' }}
					>
						{SUCCESS_HEADER}
					</Typography>
				</Stack>
				<Typography variant="body1" component="p" className="success-message">
					{SUCCESS_MESSAGE}
				</Typography>
			</Box>

			<Box className="lower-container">
				<Button href={ROUTE_LOGIN} sx={{ ':hover': { color: ColorBaseWhite } }}>
					{SUCCESS_CONTINUE_BUTTON}
				</Button>
			</Box>
		</Box>
	);
}
